const ALLERGEN_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  isIncludedAllergensDetailsLoading: false,
  isIncludedIngredientsDetailsLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  includedAllergensDetailsError: undefined,
  includedIngredientsDetailsError: undefined,
  data: undefined,
  isIncludedIngredientsDirty: false,
  isIncludedAllergensDirty: false,
  isSimpleDetailsDirty: false,
  isImageDetailsLoading: false,
  imageDetailsError: undefined,
}

export default ALLERGEN_INITIAL_STATE
